module.exports = require("unist-util-map");


//////////////////
// WEBPACK FOOTER
// external "unist-util-map"
// module id = 39
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13